module.exports = __webpack_public_path__ + "img/ico_video_off.c2b2c62a.svg";